import React, { useState } from "react"

import { RecommendationModule } from "packages/ui-shared/components/RecommendationModule/RecommendationModule"
import type {
  ProductCardProduct,
  RecommendationSection,
  RecommendationSectionModule,
} from "types"
import type { VariantTypeForNewPDP } from "../PDPBodyIndex/PDPBodyIndex"
import {
  useSliderWithFourItems,
  useSliderWithThreeItems,
} from "packages/ui-shared/components/CarouselModule/hooks/useCarouselProps"

import { oosPDPSlider, wrapper } from "./PDPRecommendations.css"
import { ATBConfirmation } from "basket_and_checkout/shared/components/ATBConfirmation"
import type { QueryResult } from "@apollo/client"
import { CarouselLoader } from "packages/ui-shared/components/CarouselLoader/CarouselLoader"

export const PDPRecommendations: React.FC<{
  recommendations: QueryResult<{
    getRecommendations: RecommendationSectionModule
  }>
  variant: Pick<VariantTypeForNewPDP, "sku" | "availability">
}> = ({
  variant,
  recommendations: {
    data: { getRecommendations: recommendations } = {},
    loading,
  },
}) => {
  const [confirmation, setConfirmation] = useState(false)
  const [confirmationProduct, setConfirmationProduct] =
    useState<ProductCardProduct>()

  const openConfirmationModal = (product: ProductCardProduct) => {
    setConfirmationProduct(product)
    setConfirmation(true)
  }

  if (loading) return <CarouselLoader />

  if (
    !recommendations ||
    recommendations.items.length === 0 ||
    recommendations.items.every(({ items }) => items.length === 0)
  ) {
    return <></>
  }

  return (
    <div
      id="frequently-bought-together"
      data-testid="frequently-bought-together"
      className={wrapper}
    >
      {confirmationProduct && (
        <ATBConfirmation
          confirmation={confirmation}
          setConfirmation={setConfirmation}
          variant={confirmationProduct}
          source="PDP"
        />
      )}
      {recommendations.items.map((rex) => (
        <RecommendationsWrapper
          key={rex.id}
          onAddToBag={openConfirmationModal}
          rec={rex}
          inStockProduct={variant?.availability?.status === "instock"}
        />
      ))}
    </div>
  )
}

const RecommendationsWrapper: React.FC<{
  rec: RecommendationSection
  inStockProduct: boolean
  onAddToBag: (product: ProductCardProduct) => void
}> = ({ rec, onAddToBag, inStockProduct }) => {
  const sliderWithFourItemsProps = useSliderWithFourItems({
    itemsLength: rec.items.length,
  })

  const sliderWithThreeItemsProps = useSliderWithThreeItems({
    itemsLength: rec.items.length,
    itemToShowMobile: 1.2,
    itemPerGroupMobile: 1,
  })

  const sliderProps = inStockProduct
    ? sliderWithFourItemsProps
    : sliderWithThreeItemsProps

  return (
    <RecommendationModule
      key={rec.id}
      {...rec}
      onAddToBag={onAddToBag}
      carouselPropsOverride={{
        ...sliderProps,
        scrollbar: true,
        showNavigation: false,
        additionalClassName: inStockProduct ? "" : oosPDPSlider,
      }}
    />
  )
}
